import { render, staticRenderFns } from "./FiltersGroup.vue?vue&type=template&id=5ba652aa&scoped=true&"
import script from "./FiltersGroup.vue?vue&type=script&lang=js&"
export * from "./FiltersGroup.vue?vue&type=script&lang=js&"
import style0 from "./FiltersGroup.vue?vue&type=style&index=0&id=5ba652aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba652aa",
  null
  
)

export default component.exports